<template>
  <div class="container">
    <Header></Header>
    <div class="user_box w1200">
      <div class="lt">
        <div class="level1">
          <div :class="['tit',showpage==1?'on':'']" @click="changeForm(1)">
            <img src="../public/images/usericon_04.png" alt v-if="showpage==1" />
            <img src="../public/images/usericon_03.png" alt v-else />
            <span>个人信息</span>
          </div>
        </div>
        <div class="level1">
          <div class="tit" @click="changeForm(2)">
            <img src="../public/images/usericon_06.png" alt />
            <span>账号管理</span>
          </div>
          <div class="level2">
            <p :class="showpage==2?'on':''" @click="changeForm(2)">修改手机号</p>
            <p :class="showpage==3?'on':''" @click="changeForm(3)">修改密码</p>
          </div>
        </div>
      </div>
      <div class="rt">
        <div class="box1" v-if="showpage==1">
          <h4 class="title">个人信息</h4>
          <div class="formbox">
            <div class="inputbox">
              <span>昵称</span>
              <input type="text" v-model="name" placeholder="请填写您的昵称" />
            </div>
            <div class="inputbox">
              <span>QQ号</span>
              <input type="text" v-model="qq_num" placeholder="请填写您的QQ" />
            </div>
            <div class="inputbox">
              <span>微信号</span>
              <input type="text" v-model="wx_num" placeholder="请填写您的微信号" />
            </div>
            <div class="inputbox">
              <span>邮箱</span>
              <input type="text" v-model="email" placeholder="请填写您的邮箱" />
            </div>
            <div class="inputbox">
              <span>推荐码</span>
              <input type="text" v-model="referral_code" placeholder="请填写推荐码" :disabled="tjm_change" />
            </div>
            <input class="submit" @click="editInfo" type="button" value="保存" />
          </div>
        </div>
        <div class="box1" v-if="showpage==2">
          <h4 class="title">账号管理-修改手机号</h4>
          <div class="formbox">
            <div class="inputbox">
              <span>旧手机</span>
              <input type="text" :value="mobile" disabled />
            </div>
            <div class="inputbox">
              <span>新手机</span>
              <input type="text" v-model="newMobile" placeholder="请填写您的新手机" />
            </div>
            <div class="inputbox">
              <span>图形验证</span>
              <input type="text" v-model="codeimg" placeholder="请填写验证码" />
              <img @click="refreshImg(1)" :src="host_url+'/index/login/captcha?num='+imgnum" alt class="codeimg" />
            </div>
            <div class="inputbox">
              <span>短信验证</span>
              <input type="text" v-model="codemsg" placeholder="请填写短信验证码" />
              <a class="getcode" @click="getMsg">{{flag?'获取验证码':'重新发送'+countDown}}</a>
            </div>
            <input class="submit" @click="modifyMobile" type="button" value="保存" />
          </div>
        </div>
        <div class="box1" v-if="showpage==3">
          <h4 class="title">账号管理-修改密码</h4>
          <div class="formbox">
            <div class="inputbox">
              <span>手机号</span>
              <input type="text" :value="mobile" disabled />
            </div>
            <div class="inputbox">
              <span>图形验证</span>
              <input type="text" v-model="codeimg01" placeholder="请填写验证码" />
              <img @click="refreshImg(2)" :src="host_url+'/index/login/captcha?num='+imgnum01" alt class="codeimg" />
            </div>
            <div class="inputbox">
              <span>短信验证</span>
              <input type="text" v-model="codemsg01" placeholder="请填写短信验证码" />
              <a class="getcode" @click="getMsg01">{{flag01?'获取验证码':'重新发送'+countDown01}}</a>
            </div>
            <div class="inputbox">
              <span>新密码</span>
              <!-- <input type="text" v-model="newpwd" placeholder="请填写您的新密码" /> -->
              <el-input placeholder="请填写您的新密码" v-model="newpwd" show-password></el-input>
            </div>
            <div class="inputbox">
              <span>确认新密码</span>
              <!-- <input type="text" v-model="newpwdConfirm" placeholder="请填写您的新密码" /> -->
              <el-input placeholder="再次输入您的新密码" v-model="newpwdConfirm" show-password></el-input>
            </div>
            <input class="submit" @click="modifyPwd" type="button" value="保存" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from "./header";
  import {
    userinfo,
    editUserinfo,
    changeMobile,
    sendCodemsg,
    changePwd
  } from '../public/js/api.js'
  export default {
    data() {
      return {
        host_url: '',
        showpage: 1,
        userinfo: {}, //个人信息
        name: null,
        qq_num: null,
        wx_num: null,
        email: null,
        referral_code: null,
        mobile: null, //修改手机号
        newMobile: '',
        codeimg: '',
        codemsg: '',
        imgnum: 1,
        flag: true,
        countDown: 60,
        codeimg01: '', //修改密码
        codemsg01: '',
        newpwd: '',
        newpwdConfirm: '',
        imgnum01: 1000,
        flag01: true,
        countDown01: 60,
        tjm_change: false
      };
    },
    methods: {
      // tab切换
      changeForm(n) {
        console.log(n);
        this.showpage = n;
        if(n==2){
          this.refreshImg(1)
        }else if(n==3){
          this.refreshImg(2)
        }
      },
      // 获取用户信息
      getUserinfo() {
        userinfo().then(res => {
          console.log(res)
          let userinfo = res.data
          this.userinfo = userinfo
          this.name = userinfo.name
          this.qq_num = userinfo.qq_num
          this.wx_num = userinfo.wx_num
          this.email = userinfo.email

          this.mobile = userinfo.mobile
          this.referral_code = userinfo.referral_code
          if(this.referral_code){
            this.tjm_change = true
          }
        })
      },
      // 修改个人信息
      editInfo() {
        let data = {
          name: this.name,
          qq_num: this.qq_num,
          wx_num: this.wx_num,
          email: this.email,
          referral_code: this.referral_code
        }
        editUserinfo(data).then(res => {
          console.log(res)
          if(res.code != 1){
            this.$message.error(res.msg)
            return
          }
          if(this.referral_code){
            this.tjm_change = true
          }
          this.$message.success(res.msg)
        })
      },
      // 刷新图片验证码
      refreshImg(n) {
        if (n == 1) {
          this.imgnum += 1
        } else if (n == 2) {
          this.imgnum01 -= 1
        }
      },
      // 获取验证码(修改手机号)
      async getMsg() {
        // alert('修改手机号')
        let that = this
        if (!that.flag) {
          return
        }
        let codeimg = this.codeimg,
          newMobile = this.newMobile
        if (!newMobile) {
          this.$message({
            message: '请输入您的新手机号'
          })
          return
        }
        if (!codeimg) {
          this.$message({
            message: '请输入图片中的验证码'
          })
          return
        }
        let data = {
          mobile: newMobile,
          scene: 'change_mobile',
          captcha: codeimg
        }
        let res = await sendCodemsg(data)
        if(res.code!=1){

        }
        // sendCodemsg(data).then(res => {
          console.log(res)
          if(res.code!=1){
            // alert('刷新手机号图片')
            that.refreshImg(1)
            this.$message.error(res.msg)
            // alert('刷新手机号图片')
            // that.refreshImg(1)
            // this.$message.error(res.msg)
          }
          if (res.code == 1) {
            this.$message.success(res.msg)
            that.flag = false
            let timer = setInterval(() => {
              if (that.countDown <= 0) {
                that.countDown = 60
                that.flag = true
                clearInterval(timer)
              }
              that.countDown--
            }, 1000)
          }else{
            // alert('刷新手机号图片')
            // that.refreshImg(1)
            // this.$message.error(res.msg)
          }
        // })
      },
      // 获取验证码(修改密码)
      getMsg01() {
            // alert('修改密码')
        // console.log('修改密码')
        let that = this
        if (!that.flag01) {
          return
        }
        let codeimg = this.codeimg01
        if (!codeimg) {
          this.$message({
            message: '请输入图片中的验证码'
          })
          return
        }
        sendCodemsg({
          mobile: this.mobile,
          scene: 'change_pwd',
          captcha: codeimg
        }).then(res => {
          console.log(res)
          if (res.code == 1) {
            this.$message.success(res.msg)
            that.flag01 = false
            let timer01 = setInterval(() => {
              if (that.countDown01 <= 0) {
                that.countDown01 = 60
                that.flag01 = true
                clearInterval(timer01)
              }
              that.countDown01--
            }, 1000)
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      // 修改手机号
      modifyMobile() {
        let newMobile = this.newMobile,
          mobile = this.mobile,
          codemsg = this.codemsg
        if(!newMobile){
          this.$message({
            message: '请输入新手机号'
          })
          return
        }
        if(!codemsg){
          this.$message({
            message: '请输入短信验证码'
          })
          return
        }
        let data = {
          mobile: newMobile,
          old_mobile: mobile,
          code: codemsg
        }
        console.log(data)
        changeMobile(data).then(res => {
          console.log(res)
          if(res.code == 1){
            this.$message.success(res.msg)
            this.mobile = newMobile
          }else{
            this.refreshImg(1)
            this.$message.error(res.msg)
          }
        })
      },
      // 修改密码
      modifyPwd(){
        let codemsg01 = this.codemsg01,
          newpwd = this.newpwd,
          newpwdConfirm = this.newpwdConfirm
        if(!codemsg01){
          this.$message({
            message: '请输入短信验证码'
          })
          return
        }
        if(!newpwd){
          this.$message({
            message: '请输入新密码'
          })
          return
        }
        if(!newpwdConfirm){
          this.$message({
            message: '请再次输入新密码'
          })
          return
        }
        let data = {
          mobile: this.mobile,
          code: codemsg01,
          password: newpwd,
          password_confirm: newpwdConfirm
        }
        console.log(data)
        changePwd(data).then(res => {
          console.log(res)
          if(res.code != 1){
            this.$message.error(res.msg)
            return
          }
          localStorage.setItem('login_psd',newpwd)
          this.$message.success(res.msg)
          this.codeimg01 = ''
          this.codemsg01 = ''
          this.newpwd = ''
          this.newpwdConfirm = ''
          this.flag01 = true
          this.countDown01 = 60
          this.refreshImg(2)
        })
      },
    },
    mounted() {

    },
    created() {
      if(this.$route.params.showpage){
        this.showpage = this.$route.params.showpage
      }
      this.getUserinfo()
      this.host_url = this.$store.state.host_url
    },
    components: {
      Header
    }
  };
</script>

<style lang="scss" scoped>
  .user_box {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    height: 940px;
    margin-bottom: 20px;
    text-align: left;

    .lt {
      width: 188px;
      height: 100%;
      background-color: #fff;
      padding: 38px 18px;
      box-sizing: border-box;

      .level1 {
        margin-bottom: 30px;
        font-size: 16px;

        .tit {
          display: flex;
          font-size: 16px;
          align-items: center;
          line-height: 20px;
          cursor: pointer;

          img {
            width: 22px;
            margin-right: 13px;
          }
        }

        .tit.on {
          color: #ff5543;
        }

        .level2 {
          font-size: 14px;
          margin-left: 34px;

          p {
            text-align: left;
            margin: 7px 0;
            cursor: pointer;
          }

          .on {
            color: #ff5543;
          }
        }
      }
    }

    .rt {
      width: 1002px;
      background-color: #fff;
      height: 100%;
      padding: 34px 45px;
      box-sizing: border-box;

      h4.title {
        font-size: 18px;
        color: #333;
        text-align: left;
        font-weight: normal;
      }
    }

    .box1 {
      .formbox {
        width: 370px;
        margin-left: 130px;
        margin-top: 35px;

        .submit {
          width: 138px;
          height: 40px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
          background-color: #ff5543;
          margin: 34px auto 0;
          font-weight: bold;
          display: block;
        }
      }

      .inputbox {
        font-size: 14px;
        color: #333;
        padding-left: 73px;
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 14px 0;
        margin-bottom: 12px;

        span {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
        }

        input {
          padding-left: 72px;
          font-size: 14px;
          background-color: #fff;
          color: #333;
        }
  
        input::-webkit-input-placeholder{
            color:#999!important;
        }

        .codeimg {
          position: absolute;
          right: 0;
          bottom: 10px;
          // width: 90px;
          // height: 32px;
          width: 116px;
          height: 40px;
          cursor: pointer;
        }

        .getcode {
          font-size: 14px;
          position: absolute;
          right: 0;
          bottom: 14px;
          text-decoration: underline;
          cursor: pointer;
          color: #666;
        }
      }
    }
  }
  /deep/ .el-input__inner{
    border: 0;
    padding: 0 72px;
  }
  /deep/ .el-input__inner::-webkit-input-placeholder{
    color:#999!important;
  }
</style>